export default __webpack_public_path__ + "static/media/ico_11.50f0bc92.png";